    export const getDevelopmentTypes = (res) => {
        let typesList = [];
        for (let field of res) {
            if (field.columnName.includes("(sqm)") && field.value !== null && (field.value !== "0" || Number(field.value) > 0)) {
                if (!typesList.includes(field.columnName.substring(0, field.columnName.length - 5))) {
                    typesList.push(field.columnName.substring(0, field.columnName.length - 6));
                }
            }
        }
        if (typesList.length === 0) {
            return "TBD";
        } else if (typesList.length === 2 && typesList.includes("Apartment") && typesList.includes("Townhouse")) {
            return "Residential";
        } else if (typesList.length > 1) {
            return "Mixed use";
        } else {
            return typesList[0];
        }
    };

    export const getPlanStatus = (permitDate) => {
        if(permitDate === null || permitDate === undefined || new Date(permitDate) > new Date()){
            return "Open";
        } else if(permitDate !== null && new Date(permitDate) <= new Date()){
            return "Closed";
        }
    }

    export const getPlanStatusByType = (devapp) => {
        if(devapp.caseNumber.indexOf("PLN") > -1){
            return getPlanStatus(devapp.milestonesCouncilConsidPermitIssD);
        } else {
            return getPlanStatus(devapp.milestonesSummaryLetterD);
        }
    }

    export const isNullOrEmpty = (value)=> {
        return value === null || value === undefined || value.trim() === "";
    }
